// Deferring callbacks to the next frame stops "ResizeObserver loop completed with
// undelivered notifications", which the CRA dev overlay reports as a fatal error.
if (typeof window !== 'undefined' && window.ResizeObserver && !window.ResizeObserver.__deferred) {
  const NativeResizeObserver = window.ResizeObserver

  class DeferredResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let frameId = null
      super((entries, observer) => {
        if (frameId !== null) {
          window.cancelAnimationFrame(frameId)
        }
        frameId = window.requestAnimationFrame(() => {
          frameId = null
          callback(entries, observer)
        })
      })
    }
  }

  DeferredResizeObserver.__deferred = true
  window.ResizeObserver = DeferredResizeObserver
}
